module.exports = __webpack_public_path__ + "tail-spin.svg?f385d5d57476225771b01ec51481f73b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tail-spin.svg
// module id = 650
// module chunks = 0